import { render, staticRenderFns } from "./TrashClient.vue?vue&type=template&id=2009da38&"
import script from "./TrashClient.vue?vue&type=script&lang=js&"
export * from "./TrashClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports